import React from 'react';

const INTAKE = {
  before_food: 'Before Food',
  after_food: 'After Food',
  with_food: 'With Food',
  empty_stomach: 'Empty Stomach',
  any_time: 'Any Time',
};

function timingStr(m) {
  const t = m.timing || [];
  const doses = m.timing_doses || {};
  return ['M', 'A', 'E', 'N'].map((c) => {
    const d = doses[c];
    if (d === 0.5) return '½';
    if (d === 1) return '1';
    return Array.isArray(t) && t.includes(c) ? '1' : '0';
  }).join('-');
}

function intakeLabel(m) {
  const raw = m.intake;
  if (!raw) return '-';
  return INTAKE[raw] || String(raw).replace(/_/g, ' ');
}

/** Prescription table matching the doctor's PastVisitDrawer layout. */
export default function PrescriptionMedsTable({ meds = [] }) {
  if (!meds.length) return null;
  return (
    <div className="overflow-x-auto -mx-1" data-testid="prescription-meds-table">
      <table className="w-full text-xs border-collapse">
        <thead>
          <tr className="text-left text-[10px] font-bold uppercase tracking-wide text-gray-500">
            <th className="px-2 py-2 border-b">#</th>
            <th className="px-2 py-2 border-b">Medicine</th>
            <th className="px-2 py-2 border-b">Dosage</th>
            <th className="px-2 py-2 border-b">Freq</th>
            <th className="px-2 py-2 border-b">Intake</th>
            <th className="px-2 py-2 border-b">Timing</th>
            <th className="px-2 py-2 border-b">Duration</th>
            <th className="px-2 py-2 border-b">Qty</th>
          </tr>
        </thead>
        <tbody>
          {meds.map((m, i) => {
            const hasRemarks = m.remarks && String(m.remarks).trim();
            const notes = hasRemarks || (m.notes && String(m.notes).trim());
            return (
              <React.Fragment key={i}>
                <tr className="hover:bg-gray-50">
                  <td className="px-2 py-2 align-top text-gray-500">{i + 1}</td>
                  <td className="px-2 py-2 align-top font-semibold text-gray-900">
                    {m.medicine_name || m.name}
                  </td>
                  <td className="px-2 py-2 align-top">{m.dosage || m.dose || '-'}</td>
                  <td className="px-2 py-2 align-top">{m.frequency || '-'}</td>
                  <td className="px-2 py-2 align-top">{intakeLabel(m)}</td>
                  <td className="px-2 py-2 align-top font-mono tracking-wider text-gray-600">
                    {(m.timing_doses && Object.keys(m.timing_doses).length) || Array.isArray(m.timing)
                      ? timingStr(m)
                      : (m.timing || '-')}
                  </td>
                  <td className="px-2 py-2 align-top">{m.duration || '-'}</td>
                  <td className="px-2 py-2 align-top">{m.quantity || '-'}</td>
                </tr>
                {notes ? (
                  <tr>
                    <td />
                    <td colSpan={7} className="px-2 pb-2">
                      <div className="inline-flex items-start gap-2 px-2.5 py-1 bg-amber-50 border-l-2 border-amber-500 rounded-sm">
                        <span className="text-[9px] font-bold uppercase tracking-wide text-amber-700 mt-0.5">
                          Remarks
                        </span>
                        <span className="text-[11px] text-amber-900">{notes}</span>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
